import React, {useState, useEffect} from 'react';
import {Container, Row, Col} from 'reactstrap';
import {connect} from 'react-redux';
import {isMobile, isAndroid, isIOS} from 'react-device-detect';
import {
  setPaymentAmountPrivate,
  handleCurrentStep,
  setSelectedProvider,
  setSelectedOrgId,
  getContactCompanyList,
  getConsumers,
  handleOrgData,
  changeHandler,
  validateHandler,
  creditCardPay,
  setFollowUpData,
  setContactFormId,
  debtPaymentHandleContactUs,
  endProccess,
  setMaxPaymentPrivate,
  setPaymentFloorsPrivate,
  setSendPayment,
  setPaymentData,
  setEmailRequested,
  setGeneralError,
  setPopUpProps,
  displayPopUp,
  setError,
  basicStepHandle,
  creditCardPayPrivate,
  getPrivateDebts,
  setIsPrivate,
  debtPaymentHandleContactUsPrivate,
  setIsJetConnection,
  setSelectedPaymentType,
  getBitPaymentStatus,
  openBitRequest,
  getBitResultStep,
  setBitPendingPopupProps,
  getBitPaymentStatusOnLoading,
  setSuccessPage,
  logout,
  clearHistory,
} from './debtPaymentBlockSlice';
import {deptPaymentDataToUpdate} from '../UpdatePaymentMethodBlock/updatePaymentMethodSlice';
import DebtPaymentStart from './DebtPaymentSteps/debtPaymentStart';
import DebtPaymentCompanySelect from './DebtPaymentSteps/debtPaymentCompanySelect';
import DebtPaymentConsumerSelect from './DebtPaymentSteps/debtPaymentConsumerSelect';
import DebtPaymentContactUs from './DebtPaymentSteps/debtPaymentContactUs';
import DebtPaymentContactUsSuccess from './DebtPaymentSteps/debtPaymentContactUsSuccess';
import DebtPaymentSuccess from './DebtPaymentSteps/debtPaymentSuccess';
import BillingCycleError from './DebtPaymentErrors/billingCycleError';
import ContactUsError from './DebtPaymentErrors/contactUsError';
import GeneralError from './DebtPaymentErrors/generalError';
import PaymentError from './DebtPaymentErrors/paymentError';
import PopUpComponent from './DebtPaymentComponents/popUpComponent';
import BitPendingPopupNotificationComponent from './DebtPaymentComponents/BitPendingPopupNotificationComponent';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {validateHandler as validatePayment, resetStore} from '../SaleBlock/Payment/PaymentSlice';
import {validateHandler as validatePaymentCG, resetStore as resetCGStore} from '../SaleBlock/PaymentCG/PaymentCGSlice';
import {resetState as resetEmailState} from '../SaleBlock/CustomerEmail/CustomerEmailSlice';
import {getDBBitStatus, resetBlock as resetBitBlock} from '../../Shared/BitPayment/bitPaymentSlice';
import DebtPaymentCreditCard from './DebtPaymentSteps/debtPaymentCreditCard';
import './debtPayment.scss';
import NoAccountsError from './DebtPaymentErrors/noAccountsError';
import PopUp from '../../Shared/Popup/PopUp';
import Config from '../../../Config';
import gaParams from '../../../utilities/analytics/constants';
import {gaEvent} from '../../../utilities/analytics/tracking';
import {TransitionGroup} from 'react-transition-group';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import {cgTypeEnum} from '../../../utilities/enums/cgTypeEnum';
import LowAmountError from './DebtPaymentErrors/lowAmountError';
import HighAmountError from './DebtPaymentErrors/highAmountError';
import GeneralErrorPrivate from './DebtPaymentErrors/generalErrorPrivate';
import NoAccountsErrorPrivate from './DebtPaymentErrors/noAccountsErrorPrivate';
import {errorEnum, bitPaymentStatusEnum, successEnum, deviceType, stepEnum} from './DebtPaymentComponents/debtPaymentEnum';
import DebtPaymentSuccessPrivate from './DebtPaymentSteps/debtPaymentSuccessPrivate';
import DebtPaymentStartPrivate from './DebtPaymentSteps/debtPaymentStartPrivate';
import ContactUsErrorPrivate from './DebtPaymentErrors/ContactUsErrorPrivate';
import WrongPaymentError from './DebtPaymentErrors/wrongPaymentError';
import DebtPaymentSelectAmountPrivate from './DebtPaymentSteps/debtPaymentSelectAmountPrivate';
import DebtPaymentSelectPaymentOption from './DebtPaymentSteps/debtPaymentSelectPaymentOption';
import loginSubTypes from '../../../constans/loginSubTypes';
import BitResultComponent from './DebtPaymentSteps/BitResultComponent';

const DebtPayment = (props) => {
  let state = props.state;
  let bit = props.bit;
  const orgDetailList = state.serverData.orgDetailList;
  const [delayedStep, setDelayedStep] = useState(state.historyStep);

  useExtendedEffect(() => {
    if (state.isLoading === true) {
      props.showAppLoader();
    } else {
      props.hideAppLoader();
    }
  }, [state.isLoading]);

  const letsStart = () => {
    gaEvent(gaParams.DEBT_PAYMENT_START.category, gaParams.DEBT_PAYMENT_START.eventType, gaParams.DEBT_PAYMENT_START.eventParams);
    props.getContactCompanyList(props.selectedFromPortal && props.selectedFromPortal !== '');
  };

  const startProcessPrivate = async ({bitEvent, selectedAmount, selectedBan, externalSystemReference}) => {
    await props.getPrivateDebts({
      bitEvent,
      selectedAmount,
      selectedBan,
      externalSystemReference,
    });
  };

  const chooseOrg = async (item) => {
    if (props.state.isPrivate) {
      gaEvent(
        gaParams.PRIVATEDEBT_CHOOSEACCOUNT_CLICK.category,
        gaParams.PRIVATEDEBT_CHOOSEACCOUNT_CLICK.eventType,
        gaParams.PRIVATEDEBT_CHOOSEACCOUNT_CLICK.eventParams,
      );
    } else {
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_DEBTLIST.category,
        gaParams.DEBT_PAYMENT_CLICK_DEBTLIST.eventType,
        gaParams.DEBT_PAYMENT_CLICK_DEBTLIST.eventParams,
      );
    }
    if (props.state.isPrivate && props.contentData?.bitPaymentOption?.value) {
      props.showAppLoader();
      getPaymentStatusesForBan(item);
    } else {
      props.handleOrgData(item);
    }
  };

  async function getPaymentStatusesForBan(item) {
    props.showAppLoader();
    await props
      .getDBBitStatus(item.number || item)
      .catch((err) => {
        props.hideAppLoader();
        props.basicStepHandle(errorEnum.BITGENERALERROR);
      })
      .then((res) => {
        props.hideAppLoader();
        if (res.payload?.status) {
          if (res.payload.status == 'New') {
            if (state.currentStep === stepEnum.SELECTPAYMENTTYPE) {
              openBitRequest();
            } else {
              props.handleOrgData(item);
            }
          } else {
            //show UI result
            if (res.payload.status.toLowerCase() == bitPaymentStatusEnum.BITPENDING) {
              //show popup
              props.setBitPendingPopupProps(item);
            } else {
              const nextStep = getBitResultStep(res.payload.status, res.payload.statusCode);
              const debtAmount = item.amount;
              const paymentAmount = res.payload.paymentAmount;
              if (nextStep == successEnum.PAYMENTSUCCESSPRIVATE) {
                const receptionNo = res.payload.receptionNo;
                props.setSuccessPage({receptionNo, paymentAmount, debtAmount});
              }

              props.basicStepHandle(nextStep);
            }
          }
        } else {
          props.basicStepHandle(errorEnum.BITGENERALERROR);
        }
      });
  }

  const handleSetEmailRequest = () => {
    if (props.state.isPrivate == false) {
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_EMAIL.category,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_EMAIL.eventType,
        gaParams.DEBT_PAYMENT_CLICK_CREDITCARDPAY_EMAIL.eventParams,
      );
    }
    props.setEmailRequested();
  };

  const gaEventCCError = () => {
    if (props.state.isPrivate == false) {
      gaEvent(
        gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_CCERROR.category,
        gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_CCERROR.eventType,
        gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_CCERROR.eventParams,
      );
    }
  };

  const gaEventFormError = () => {
    if (props.state.isPrivate == false) {
      gaEvent(
        gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_FORMERROR.category,
        gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_FORMERROR.eventType,
        gaParams.DEBT_PAYMENT_SHOW_CREDITCARDPAY_FORMERROR.eventParams,
      );
    }
  };

  const cleanStore = () => {
    props.endProccess();
    props.resetEmailState();
    props.resetStore();
    props.resetCGStore();
    props.resetBitBlock();
    props.clearHistory();
  };

  const OpenModal = (popUpProps) => {
    props.setPopUpProps(popUpProps);
    props.displayPopUp();
  };

  //step 2
  const setSelectedForUpdate = async (idNumber, orgId, skipStep) => {
    if (orgId != undefined && state.selectedProvider != undefined) {
      if (props.state.isPrivate == false) {
        gaEvent(
          gaParams.DEBT_PAYMENT_CLICK_CHOOSECOMPANY.category,
          gaParams.DEBT_PAYMENT_CLICK_CHOOSECOMPANY.eventType,
          gaParams.DEBT_PAYMENT_CLICK_CHOOSECOMPANY.eventParams,
        );
      }
      const result = await props.getConsumers({
        idNumber,
        orgId,
        selectedProvider: state.selectedProvider,
        skipStep,
      });
    }
  };

  const createAndSendPaymentData = () => {
    props.validatePaymentCG(props.payment.form).then((res) => {
      if (res.payload.confirmationNumber) {
        props.setSendPayment();
      } else {
        gaEventFormError();
      }
    });
  };
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }, 100);

    //private
    props.setIsPrivate(props.contentData?.isPrivate?.value ? true : false);
    if (props.contentData?.isPrivate?.value) {
      if (props.contentData?.maxPaymentAmountPrivate?.value) {
        props.setMaxPaymentPrivate(props.contentData?.maxPaymentAmountPrivate?.value);
      }
      if (
        props.contentData?.firstPaymentFloor?.value &&
        props.contentData?.firstPaymentFloorPayments?.value &&
        props.contentData?.secondPaymentFloor?.value &&
        props.contentData?.secondPaymentFloorPayments?.value &&
        props.contentData?.thirdPaymentFloor?.value &&
        props.contentData?.thirdPaymentFloorPayments?.value &&
        props.contentData?.fourthPaymentFloorPayments?.value
      ) {
        props.setPaymentFloorsPrivate({
          firstFloorAmount: props.contentData?.firstPaymentFloor?.value,
          secondFloorAmount: props.contentData?.secondPaymentFloor?.value,
          thirdFloorAmount: props.contentData?.thirdPaymentFloor?.value,
          firstFloorPayments: props.contentData?.firstPaymentFloorPayments?.value,
          secondFloorPayments: props.contentData?.secondPaymentFloorPayments?.value,
          thirdFloorPayments: props.contentData?.thirdPaymentFloorPayments?.value,
          fourthFloorPayments: props.contentData?.fourthPaymentFloorPayments?.value,
        });
      }
    }

    return () => {
      cleanStore();
    };
  }, []);

  useEffect(() => {
    //JET
    if (props.authentication?.userDetails?.Impersonate && props.authentication?.userDetails?.loginSubType == loginSubTypes.ONBEHALF) {
      props.setIsJetConnection(props.authentication.userDetails.Ban);
    }
  }, [props.authentication.userDetails]);

  useEffect(() => {
    if (props.payment.form.valid) {
      props.showAppLoader();
    }
  }, [props.payment.form.valid]);

  const makePayment = async (data) => {
    if (props.contentData?.isPrivate?.value) {
      await props.creditCardPayPrivate(data);
    } else {
      await props.creditCardPay(data);
    }
  };

  const getCGDataForCreditCard = (generalObject) => {
    return {
      ...generalObject,
      idNumber: props.payment.CGData.id,
      CCToken: props.payment.CGData.ccToken,
      cardYear: props.payment.CGData.cardYear,
      cardMonth: props.payment.CGData.cardMonth,
      cardCvv: '', //When in EMV mode, we do not send CVV to backend.
      authNo: props.payment.CGData.authNumber,
      creditCardType: props.payment.CGData.ccType,
      terminalNumber: cgTypeEnum.DEBTPAYMENT,
      billByEmail: state.payment.isEmailRequested && props.billByEmail,
    };
  };

  const redirectToLobby = () => {
    if (props.contentData?.isPrivate?.value) {
      gaRedirectLobbyPrivate();
      props.context.navigateTo(Config.lobbyUrl);
    } else {
      props.context.navigateTo(Config.businessLobbyUrl);
    }
  };

  const gaRedirectLobbyPrivate = () => {
    switch (state.currentStep) {
      case errorEnum.BIGAMOUNT:
        gaEvent(
          gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.category,
          gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.eventType,
          'סכום חוב גבוה מדי',
        );
        break;
      case errorEnum.BILLINGCYCLE:
        gaEvent(gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.category, gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.eventType, 'חשבון בחיוב');
        break;
      case errorEnum.LOWAMOUNT:
        gaEvent(gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.category, gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.eventType, 'אין חוב');
        break;
      case errorEnum.NOACCOUNTSPRIVATE:
        gaEvent(
          gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.category,
          gaParams.PRIVATEDEBT_SPECIALERROR_END_CLICK.eventType,
          'לא נמצאו חשבונות',
        );
        break;
      case successEnum.PAYMENTSUCCESS:
        gaEvent(
          gaParams.PRIVATEDEBT_PAYMENTSUCCESS_END_CLICK.category,
          gaParams.PRIVATEDEBT_PAYMENTSUCCESS_END_CLICK.eventType,
          'התשלום בוצע בהצלחה',
        );
        break;
      case errorEnum.PAYMENTFAILED:
        gaEvent(
          gaParams.PRIVATEDEBT_PAYMENTFAIL_END_CLICK.category,
          gaParams.PRIVATEDEBT_PAYMENTFAIL_END_CLICK.eventType,
          gaParams.PRIVATEDEBT_PAYMENTFAIL_END_CLICK.eventParams,
        );
        break;
    }
  };

  const endClickPrivate = () => {
    //current selected customer
    //customer list without it
    //if there are none, go and return to lobby
    //else, fetch data again and return to select
    const currentCustomer = props.state.savedData;
    const orgsList = props.state.serverData?.orgsList?.filter(
      (o) => parseFloat(o.amount) > 0 && parseFloat(o.amount) <= props.state.maxPrivatePayment && o.number != currentCustomer.number,
    );
    if (orgsList?.length > 0) {
      props.clearHistory();
      const bitEvent = false;
      let selectedAmount, selectedBan, externalSystemReference;

      startProcessPrivate({
        bitEvent,
        selectedAmount,
        selectedBan,
        externalSystemReference,
      });
    } else {
      gaRedirectLobbyPrivate();
      redirectToLobby();
    }
  };

  const redirectToUpdatePaymentMethod = () => {
    if (props.isPrivate) {
      switch (props.currentStep) {
        case successEnum.PAYMENTSUCCESS:
          gaEvent(
            gaParams.PRIVATEDEBT_PAYMENTSUCCESS_UPDATEPAYMENT_CLICK.category,
            gaParams.PRIVATEDEBT_PAYMENTSUCCESS_UPDATEPAYMENT_CLICK.eventType,
            'תשלום בוצע בהצלחה',
          );
          break;
        case errorEnum.PAYMENTFAILED:
          gaEvent(
            gaParams.PRIVATEDEBT_PAYMENTFAIL_UPDATEPAYMENT_CLICK.category,
            gaParams.PRIVATEDEBT_PAYMENTFAIL_UPDATEPAYMENT_CLICK.eventType,
            gaParams.PRIVATEDEBT_PAYMENTFAIL_UPDATEPAYMENT_CLICK.eventParams,
          );
          break;
      }
    }
    const updatePaymentMethodObj = {
      contactId: state.contactId,
      contactPhoneNumber: state.contactPhoneNumber,
      selectedForUpdate: {
        idNumber: state.savedData.idNumber,
        customersPaymentData: [
          {
            customersList: [
              {
                number: state.savedData.number,
                checked: true,
              },
            ],
          },
        ],
      },
      selectedProvider: state.selectedProvider,
    };

    props.deptPaymentDataToUpdate(updatePaymentMethodObj);
    props.context.navigateTo(props.contentData.updatePaymentMethod.value);
  };

  useEffect(() => {
    if (state.paymentData.pay && props.payment.CCError !== true) {
      const generalObject = {
        account: props.state.savedData.number,
        email: props.payAuthEmail.form.email,
        phoneNumber: props.isPrivate ? props.authentication?.userDetails?.contactNumber : props.state.contactPhoneNumber,
        orgType: props.state.selectedProvider,
        amount: props.isPrivate ? props.state.paymentAmountPrivate : props.state.savedData.amount,
        CCToken: '',
        cardYear: '',
        cardMonth: '',
        cardCvv: '',
        creditCardType: '',
        paymentNo: !props.payment.paymentCount || props.payment.paymentCount === '' ? '1' : props.payment.paymentCount,
        firmId: state.savedData.idNumber,
        orgId: state.chosenOrgId,
      };

      const completPaymentData = getCGDataForCreditCard(generalObject);

      props.setPaymentData(completPaymentData);

      props.resetStore();

      makePayment(completPaymentData);
    }
  }, [props.payment.CCData.CCToken, state.paymentData.pay]);

  useEffect(() => {
    if (props.payment.CCError) {
      gaEventCCError();
    }
  }, [props.payment.CCError]);

  useEffect(() => {
    if (props.payment.isTermsMsg) {
      props.hideAppLoader();
    }
  }, [props.payment.isTermsMsg]);

  useExtendedEffect(
    (runSideEffects) => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      if (state.currentStep) {
        props.hideAppLoader();
        setDelayedStep(null);
        props.basicStepHandle(state.currentStep);
        setTimeout(
          () => {
            setDelayedStep(state.currentStep);
          },
          runSideEffects() ? 0 : 250,
        );
      }
    },
    [state.currentStep],
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects() && state.currentStep !== state.stepToHandle) {
        props.showAppLoader();
        props.handleCurrentStep({
          currentStep: state.stepToHandle,
          skipStep: state.skipStep,
        });
      }
    },
    [state.stepToHandle],
  );

  useClearStateResetFlag();

  const handleAmount = (v) => {
    props.setPaymentAmountPrivate({v: v, bitPaymentOption: props.contentData?.bitPaymentOption?.value});
  };

  const openBitRequest = () => {
    const request = {
      customerEmail: state.payment.isEmailRequested ? props.payAuthEmail.form.email : '',
      paymentAmount: state.paymentAmountPrivate,
      ban: state.savedData.number,
      paymentSubject: 0,
      billByEmail: state.payment.isEmailRequested && props.billByEmail,
      device: !isMobile ? deviceType.DESKTOP : isAndroid ? deviceType.ANDROID : deviceType.IOS,
      totalAmount: state.savedData.amount,
    };

    props.openBitRequest(request);
  };

  const validateBitRequest = () => {
    props.getBitPaymentStatus({
      ban: state.savedData.number,
      externalSystemReference: bit.externalSystemReference || state.bitExternalSystemReference,
    });
  };

  const validateStatusOnPending = () => {
    props.getBitPaymentStatusOnLoading({
      ban: state.savedData.number,
      externalSystemReference: bit.externalSystemReference || state.bitExternalSystemReference,
    });
  };

  const basicProps = {
    isMobile: isMobile,
    currentStep: delayedStep,
    historyStep: state.historyStep,
    handleCurrentStep: props.basicStepHandle,
    maxPaymentAmountPrivate: props.state.maxPrivatePayment,
    isPrivate: props.contentData?.isPrivate?.value ? true : false,
    bitPaymentOption: props.contentData?.bitPaymentOption?.value ? true : false,
    phoneNumber: props.contactNumber,
    orgLength: state.serverData?.orgsList?.length,
    savedCustomerData: props.state.savedData,
    isJetConnection: state.isJetConnection,
    activeJetBan: state.isJetConnection ? state.activeJetBan : null,
    selectedPaymentType: state.selectedPaymentType,
    selectedBan: state.savedData?.number,
    idNumber: state.savedData?.idNumber,
  };

  const renderBusiness = () => {
    return (
      <Container fluid className='debtpayment-main'>
        <Row className='debtpayment-content justify-content-md-center'>
          <Col className='pr-0 pl-0'>
            <TransitionGroup component={null}>
              <DebtPaymentStart onclick={letsStart} {...basicProps} />
              <DebtPaymentCompanySelect
                error={state.error}
                placeholder='בחר ח.פ'
                radioBtns={state.radioBtns}
                selectedProvider={state.selectedProvider}
                setSelectedProvider={props.setSelectedProvider}
                selectedOrgId={state.selectedOrgId}
                setSelectedOrgId={props.setSelectedOrgId}
                setSelectedForUpdate={setSelectedForUpdate}
                orgDetailList={orgDetailList}
                redirectToLobby={redirectToLobby}
                setGeneralError={props.setGeneralError}
                selectedFromPortal={props.selectedFromPortal}
                skipStep={state.prepSkipStep}
                {...basicProps}
              />
              <DebtPaymentConsumerSelect
                orgsList={state.serverData.orgsList}
                onclick={chooseOrg}
                setError={props.setError}
                {...basicProps}
              />
              <DebtPaymentCreditCard
                idNumber={props.idNumber}
                payForm={null}
                createAndSendPaymentData={createAndSendPaymentData}
                setFollowUpData={props.setFollowUpData}
                savedData={state.savedData}
                selectedProvider={state.selectedProvider}
                setEmailRequested={handleSetEmailRequest}
                isEmailRequested={state.payment.isEmailRequested}
                isEmailRequestedError={props.isEmailRequestedError}
                email={props.payAuthEmail.form.email}
                openModal={OpenModal}
                ccToken={props.payment.CCToken}
                source={props.contentData?.contentType?.[props.contentData?.contentType?.length - 1]}
                {...basicProps}
              />
              <DebtPaymentContactUs
                changeHandler={props.changeHandler}
                validateHandler={props.validateHandler}
                formState={state.form}
                idNumber={props.idNumber}
                chosenOrgId={state.chosenOrgId}
                setContactFormId={props.setContactFormId}
                contactUs={props.debtPaymentHandleContactUs}
                followUpData={state.followUpData}
                selectedProvider={state.selectedProvider}
                savedData={state.savedData}
                email={props.payAuthEmail.form.email}
                {...basicProps}
              />
              <DebtPaymentContactUsSuccess onclick={redirectToLobby} {...basicProps} />
              <DebtPaymentSuccess
                paymentData={state.paymentData}
                noPaymentMethod={state.savedData.noPaymentMethod}
                email={state.paymentData?.email}
                onclick={redirectToLobby}
                updatePaymentMethod={redirectToUpdatePaymentMethod}
                {...basicProps}
              />
              <BillingCycleError error={state.error} onclick={redirectToLobby} {...basicProps} />
              <ContactUsError onclick={redirectToLobby} {...basicProps} />
              <GeneralError onclick={redirectToLobby} {...basicProps} />
              <NoAccountsError error={state.error} onclick={redirectToLobby} {...basicProps} />
              <PaymentError
                buttonText={'או פנה אלינו כאן'}
                setFollowUpData={props.setFollowUpData}
                noPaymentMethod={state.savedData.noPaymentMethod}
                updatePaymentMethod={redirectToUpdatePaymentMethod}
                onclick={redirectToLobby}
                {...basicProps}
              />
            </TransitionGroup>
          </Col>
        </Row>
        <PopUp showPopUp={state.showPopUp} onClose={() => props.displayPopUp()}>
          <PopUpComponent {...state.popUpProps} closeModal={props.displayPopUp} />
        </PopUp>
      </Container>
    );
  };

  const renderPrivate = () => {
    return (
      <Container fluid className='debtpayment-main'>
        <Row className='debtpayment-content justify-content-md-center'>
          <Col className='pr-0 pl-0'>
            <DebtPaymentStartPrivate onclick={startProcessPrivate} {...basicProps} selectedFromPortal={props.selectedFromPortal} />
            <DebtPaymentConsumerSelect orgsList={state.serverData.orgsList} onclick={chooseOrg} setError={props.setError} {...basicProps} />
            <DebtPaymentSelectAmountPrivate
              maxAmount={state.savedData?.amount}
              savedData={state.savedData}
              handler={handleAmount}
              {...basicProps}
            />
            <DebtPaymentSelectPaymentOption
              savedData={state.savedData}
              privateAmount={state.paymentAmountPrivate}
              setSelectedPaymentType={props.setSelectedPaymentType}
              setEmailRequested={handleSetEmailRequest}
              isEmailRequested={state.payment.isEmailRequested}
              isEmailRequestedError={props.isEmailRequestedError}
              email={props.payAuthEmail.form.email}
              bitIsReady={bit.isReady}
              bitReturnEvent={state.bitReturnEvent}
              validateStatus={validateBitRequest}
              validateStatusOnPending={validateStatusOnPending}
              //openBitRequest={openBitRequest}
              getPaymentStatusesForBan={getPaymentStatusesForBan}
              {...basicProps}
            />

            <DebtPaymentCreditCard
              createAndSendPaymentData={createAndSendPaymentData}
              setEmailRequested={handleSetEmailRequest}
              isEmailRequested={state.payment.isEmailRequested}
              isEmailRequestedError={props.isEmailRequestedError}
              setFollowUpData={props.setFollowUpData}
              savedData={state.savedData}
              privateAmount={state.paymentAmountPrivate}
              totalDebtPrivate={state.savedData.amount}
              selectedProvider={'cellcom'}
              payForm={props.payment.form}
              openModal={OpenModal}
              ccToken={props.payment.CCToken}
              source={props.contentData?.contentType?.[props.contentData?.contentType?.length - 1]}
              paymentFloorData={{
                firstFloorAmount: state.firstFloorAmount,
                secondFloorAmount: state.secondFloorAmount,
                thirdFloorAmount: state.thirdFloorAmount,
                firstFloorPayments: state.firstFloorPayments,
                secondFloorPayments: state.secondFloorPayments,
                thirdFloorPayments: state.thirdFloorPayments,
                fourthFloorPayments: state.fourthFloorPayments,
              }}
              idNumber={props.idNumber}
              {...basicProps}
            />
            <DebtPaymentContactUs
              changeHandler={props.changeHandler}
              validateHandler={props.validateHandler}
              formState={state.form}
              idNumber={props.idNumber}
              chosenOrgId={state.chosenOrgId}
              setContactFormId={props.setContactFormId}
              contactUs={props.debtPaymentHandleContactUsPrivate}
              followUpData={state.followUpData}
              selectedProvider={state.selectedProvider}
              savedData={state.savedData}
              email={props.payAuthEmail.form.email}
              {...basicProps}
            />
            <DebtPaymentContactUsSuccess onclick={redirectToLobby} {...basicProps} />
            <DebtPaymentSuccessPrivate
              paymentData={state.paymentData}
              privateAmount={state.paymentAmountPrivate}
              paused={state.savedData.paused}
              debtAmount={state.savedData.amount}
              noPaymentMethod={state.savedData.noPaymentMethod}
              email={state.paymentData?.email}
              onclick={endClickPrivate}
              updatePaymentMethod={redirectToUpdatePaymentMethod}
              notifyTV={state.notifyTV}
              bitReturnEvent={state.bitReturnEvent}
              {...basicProps}
            />
            <WrongPaymentError onclick={redirectToLobby} {...basicProps} />
            <BillingCycleError error={state.error} onclick={redirectToLobby} {...basicProps} />
            <GeneralErrorPrivate onclick={redirectToLobby} {...basicProps} />
            <ContactUsErrorPrivate onclick={redirectToLobby} {...basicProps} />
            <LowAmountError onclick={redirectToLobby} {...basicProps} />
            <HighAmountError onclick={redirectToLobby} {...basicProps} />
            <NoAccountsErrorPrivate onclick={redirectToLobby} {...basicProps} />
            <PaymentError
              debtAmount={state.savedData.amount}
              privateAmount={state.paymentAmountPrivate}
              buttonText={'או פנה אלינו כאן'}
              setFollowUpData={props.setFollowUpData}
              noPaymentMethod={state.savedData.noPaymentMethod}
              updatePaymentMethod={redirectToUpdatePaymentMethod}
              onclick={redirectToLobby}
              {...basicProps}
            />
            <BitResultComponent
              redirectToLobby={redirectToLobby}
              savedData={state.savedData}
              paymentData={state.paymentData}
              endClickPrivate={endClickPrivate}
              privateAmount={state.paymentAmountPrivate}
              bitReturnEvent={state.bitReturnEvent}
              logout={props.logout}
              {...basicProps}
            />
          </Col>
        </Row>
        <PopUp
          className={state.bitPendingPopup ? 'bit-pending-popup' : ''}
          showPopUp={state.showPopUp}
          onClose={() => props.displayPopUp()}>
          <>
            {state.bitPendingPopup ? (
              <BitPendingPopupNotificationComponent closeModal={props.displayPopUp} redirectToLobby={redirectToLobby} />
            ) : (
              <PopUpComponent {...state.popUpProps} closeModal={props.displayPopUp} />
            )}
          </>
        </PopUp>
      </Container>
    );
  };

  const renderBlock = () => {
    if (props.contentData?.isPrivate?.value) {
      return renderPrivate();
    }
    return renderBusiness();
  };

  return renderBlock();
};

const mapStateToProps = (state) => {
  return {
    state: state.debtPaymentBlock,
    payment: state.PaymentCG,
    payAuthEmail: state.CustomerEmail,
    idNumber: state.authentication.loginData.userDetails.IDNumber,
    contactNumber: state.authentication.loginData.userDetails.contactNumber,
    isEmailRequestedError: state.CustomerEmail.form.errors.email,
    selectedFromPortal: state.portalsBlock.selectedHetPay,
    authentication: state.authentication.loginData,
    isPrivate: state.debtPaymentBlock.isPrivate,
    bit: state.bitPayment,
    billByEmail: state.CustomerEmail.isReceivingBill,
  };
};

const mapDispatchToProps = {
  debtPaymentHandleContactUsPrivate,
  handleCurrentStep,
  setSelectedProvider,
  setSelectedOrgId,
  getContactCompanyList,
  getConsumers,
  handleOrgData,
  creditCardPay,
  basicStepHandle,
  showAppLoader,
  hideAppLoader,
  validatePaymentCG,
  resetStore,
  resetCGStore,
  setPaymentData,
  setSendPayment,
  changeHandler,
  validatePayment,
  validateHandler,
  setFollowUpData,
  setContactFormId,
  debtPaymentHandleContactUs,
  endProccess,
  setMaxPaymentPrivate,
  setPaymentFloorsPrivate,
  setEmailRequested,
  setGeneralError,
  setPopUpProps,
  displayPopUp,
  resetEmailState,
  setError,
  deptPaymentDataToUpdate,
  creditCardPayPrivate,
  getPrivateDebts,
  setIsPrivate,
  setPaymentAmountPrivate,
  setIsJetConnection,
  getDBBitStatus,
  resetBitBlock,
  setSelectedPaymentType,
  getBitPaymentStatus,
  openBitRequest,
  setBitPendingPopupProps,
  getBitPaymentStatusOnLoading,
  setSuccessPage,
  logout,
  clearHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(DebtPayment);
